import { render } from "./UsersIcon.vue?vue&type=template&id=21e4079f"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/UsersIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21e4079f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21e4079f', __exports__)) {
    api.reload('21e4079f', __exports__)
  }
  
  module.hot.accept("./UsersIcon.vue?vue&type=template&id=21e4079f", () => {
    api.rerender('21e4079f', render)
  })

}


export default __exports__